import { render } from "./CoffeeRail.vue?vue&type=template&id=247613f9&scoped=true"
import script from "./CoffeeRail.vue?vue&type=script&lang=js"
export * from "./CoffeeRail.vue?vue&type=script&lang=js"

import "./CoffeeRail.vue?vue&type=style&index=0&id=247613f9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-247613f9"]])

export default __exports__